module.exports = __webpack_public_path__ + "f9b9e863174f72f5f2233946e5c7dc8a.svg";